import HolidayCreatePage from './HolidayCreatePage';

export default HolidayCreatePage;
